require('dotenv').config();
module.exports = {
    api_key : process.env.REACT_APP_FACEBOOK_APP_ID
}